import { get, getRawValue } from '../../../utils/get';
import { CONTEXT_PROPS } from '../../../types/ContextProps';
import { getKeys as _getKeys } from '../../../adapters/utils';
var IDs = {
  INDEX_PAGE: 'page.index',
  GROUP_TAB_TITLE: 'group.tab.title',
  GROUP_NAME: 'group.name',
  GROUP_DESCRIPTION: 'group.description',
  GROUP_IMAGE_URL: 'group.image.url',
  GROUP_IMAGE_WIDTH: 'group.image.width',
  GROUP_IMAGE_HEIGHT: 'group.image.height',
  GROUP_TAB_URL: 'group.tab.url'
};
var userVisible = [];
export default {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.GROUP_TAB_TITLE] = get(item, 'tabs.media'), _ref[IDs.GROUP_NAME] = get(item, 'group.details.title'), _ref[IDs.GROUP_DESCRIPTION] = get(item, 'group.details.description'), _ref[IDs.GROUP_IMAGE_URL] = get(item, 'group.details.logoUrl'), _ref[IDs.GROUP_IMAGE_WIDTH] = get(item, ''), _ref[IDs.GROUP_IMAGE_HEIGHT] = get(item, ''), _ref[IDs.GROUP_TAB_URL] = get(item, ''), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {},
  getSlug: function getSlug() {
    return '';
  },
  updateItemDataWithSlug: function updateItemDataWithSlug(item) {
    return item;
  },
  getBiData: function getBiData() {},
  getKeys: function getKeys() {
    return _getKeys(IDs, userVisible);
  }
};